import buttonLandingConfig from '../configs';

const initialState = {
  config: buttonLandingConfig,
};

const buttonLanding = (state = initialState) => state;

export default buttonLanding;
